<template>
<!--    eslint-disable -->
    <page-estates-item-finuslugi
        v-bind:estate-data='JSON.parse(`{\u0022id\u0022: 22, \u0022name\u0022: \u0022«Магнит» в Домодедово\u0022, \u0022status\u0022: \u0022new\u0022, \u0022type\u0022: {\u0022id\u0022: 2, \u0022name\u0022: \u0022Продуктовый Street Retail\u0022, \u0022is_active\u0022: true, \u0022icon\u0022: \u0022street\u002Dretail\u0022}, \u0022investment_types\u0022: [{\u0022id\u0022: 2, \u0022name\u0022: \u0022direct\u0022}], \u0022address\u0022: \u0022ЖК «Домодедово Парк», корпус 13\u0022, \u0022finance\u0022: {\u0022total_cost\u0022: \u0022181000000.00\u0022, \u0022target_profitability\u0022: \u002216\u0022, \u0022current_profitability\u0022: \u00220.0\u0022, \u0022target\u0022: 210000000, \u0022minimum_investment_amount\u0022: 110000, \u0022current_dividend_profitability\u0022: \u00220.0\u0022, \u0022target_dividend_profitability\u0022: \u002210\u0022, \u0022cap_rate\u0022: \u002210.20\u0022}, \u0022balance\u0022: \u0022150195500.00\u0022, \u0022url\u0022: \u0022/estate/22/\u0022, \u0022created\u0022: \u00222025\u002D06\u002D18T15:44:16.079967+03:00\u0022, \u0022modified\u0022: \u00222025\u002D09\u002D25T16:19:49.470876+03:00\u0022, \u0022description\u0022: \u002211 помещений на первом этаже ЖК «Домодедово Парк» в корпусе №13, который будет введен в эксплуатацию в 4 кв. 2025 г.\u005Cr\u005CnОбъект расположен в центре огромного ЖК с дефицитом коммерческой недвижимости.\u005Cr\u005CnЯкорный арендатор \u002D «Магнит» (8 помещений) и 3 помещения для более мелких арендаторов.\u0022, \u0022document\u0022: \u0022https://storage.yandexcloud.net/se\u002Dprod\u002Dmedia/estates/documents/22/%D0%9C%D0%B5%D0%BC%D0%BE%D1%80%D0%B0%D0%BD%D0%B4%D1%83%D0%BC_%D0%94%D0%BE%D0%BC%D0%BE%D0%B4%D0%B5%D0%B4%D0%BE%D0%B2%D0%BE_%D0%9F%D0%B0%D1%80%D0%BA_3%D0%B8%D1%80%D0%B0%D1%83%D0%BD%D0%B4_1758806251.pdf\u0022, \u0022document_title\u0022: \u0022Презентация по объекту\u0022, \u0022image\u0022: \u0022https://cdn.simpleestate.ru/images/estates/22/%D0%91%D0%B5%D0%B7_%D0%B7%D0%B0%D0%B3%D0%BE%D0%BB%D0%BE%D0%B2%D0%BA%D0%B0_1757324594.png\u0022, \u0022youtube_video\u0022: null, \u0022order\u0022: 0, \u0022is_active\u0022: true, \u0022gba\u0022: 710, \u0022gla\u0022: 710, \u0022occupancy\u0022: 72, \u0022investment_rounds\u0022: [{\u0022is_active\u0022: false, \u0022target\u0022: 82500000, \u0022balance\u0022: \u002282500000.00\u0022}, {\u0022is_active\u0022: false, \u0022target\u0022: 52192500, \u0022balance\u0022: \u002237390500.00\u0022}, {\u0022is_active\u0022: true, \u0022target\u0022: 75307500, \u0022balance\u0022: \u002230305000.00\u0022}], \u0022quarterly_reports\u0022: [], \u0022share_price\u0022: \u002211000.00\u0022, \u0022overage_limit\u0022: \u002210.0\u0022, \u0022can_invest\u0022: true, \u0022current_investment_request_id\u0022: null}`)'
    >
        <plugin-estates-navigable-container-finuslugi inline-template v-bind:estate-id="22">
            <article class="plugin-estates-navigable-container">
                <div class="plugin-estates-navigable-container__content">
                    <div class="plugin-estates-navigable-container__content-item"
                         ref="item0"
                         id="Инвестиционный тезис"
                    >
                        <div class="common-ckeditor">
                            <h1>Инвестиционный тезис</h1>
                        </div>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>

                        <section class="common-columns-36">
                            <section class="common-columns-36__item _common_width_16 _common_offset_0 _sm_width_36 _sm_offset_0">
                                <div class="common-ckeditor">
                                    <h2>Новостройка с «Магнитом» в отличной локацией и по выгодной цене </h2>

                                    <p style="text-align: justify;"></p>

                                    <p style="text-align: justify;">Инвестиционная привлекательность объекта:</p>

                                    <ul style="">
                                        <li style="text-align: justify;">Расположение в центре густонаселенного ЖК «Домодедово
                                            Парк», где уже построены и заселены дома на 8 144 квартир и два корпуса на 752 квартиры,
                                            которые будут введены в эксплуатацию в 4 кв. 2025 г.;
                                        </li>
                                        <li style="text-align: justify;">Выгодня цена м2 и доходность сделки: Cap Rate сделки
                                            10%-11,5% (окупаемость 8-8,5 лет) и ценой 255К руб. / м2 намного выгоднее рыночных
                                            значений в 350К+ руб./ м2 и Cap Rate ~7%-8%;
                                        </li>
                                        <li style="text-align: justify;">Уже подписан предварительный договор аренды с «Магнитом» на
                                            510 м2;
                                        </li>
                                        <li style="text-align: justify;">Супермаркет быстро наберет обороты, так как все дома уже
                                            построены и заселены;
                                        </li>
                                        <li style="text-align: justify;">Предоставляется комфортная рассрочка до ввода ЖК в
                                            эксплуатацию, которая позволяет минимизировать привлечение долга;
                                        </li>
                                        <li style="text-align: justify;">В ЖК наблюдается сильный дефицит коммерции - в ближайших
                                            домах на 3 411 квартир нет коммерческой инфраструктуры на первых этажах.
                                        </li>
                                        <li style="text-align: justify;"><strong>Ожидаемая долгосрочная доходность в базовом
                                            сценарии (10 лет): 16% годовых (средняя дивидендная доходность 10% годовых)</strong>
                                        </li>
                                    </ul>
                                </div>

                                <plugin-spacer inline-template>
                                    <div class="plugin-spacer _desktop" style="height: 0px"></div>
                                </plugin-spacer>
                                <plugin-spacer inline-template>
                                    <div class="plugin-spacer _mobile" style="height: 20px"></div>
                                </plugin-spacer>
                            </section>
                            <section class="common-columns-36__item _common_width_20 _common_offset_0 _sm_width_36 _sm_offset_0">
                                <plugin-illustration
                                    v-bind:image="'https://cdn.simpleestate.ru/plugins/illustration/%D0%9A%D0%B0%D1%80%D1%82%D0%B0.png'"
                                    v-bind:height-factor="69"
                                >
                                </plugin-illustration>
                            </section>
                        </section>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>

                        <section class="common-columns-36">
                            <section class="common-columns-36__item _common_width_16 _common_offset_0 _sm_width_36 _sm_order_2 _sm_offset_0">
                                <plugin-illustration
                                    v-bind:image="'https://cdn.simpleestate.ru/plugins/illustration/%D0%90%D1%80%D0%B5%D0%BD%D0%B4%D0%B0%D1%82%D0%BE%D1%80%D1%8B.png'"
                                    v-bind:height-factor="60"
                                >
                                </plugin-illustration>
                            </section>
                            <section class="common-columns-36__item _common_width_18 _common_offset_2 _sm_width_36 _sm_order_1 _sm_offset_0">
                                <div class="common-ckeditor">
                                    <h2>Уже заключен предварительный договор аренды с супермаркетом «Магнит» на 10 лет</h2>

                                    <p style="text-align: justify;"></p>

                                    <p style="text-align: justify;">«Магнит» является одной из ведущих розничных сетей в России по
                                        торговле продуктами питания.</p>

                                    <p style="text-align: justify;">Ключевые условия аренды с «Магнитом» в ЖК «Домодедово
                                        Парк»:</p>

                                    <ul>
                                        <li style="text-align: justify;">Арендная плата составляет 1 275 000 руб. / мес. (ставка
                                            аренды 2 500 руб. / м2 / мес.) с привязкой аренды от товарооборота на уровне 5%;
                                        </li>
                                        <li style="text-align: justify;">Занимаемая площаль 510 м2 (8 помещений);</li>
                                        <li style="text-align: justify;">Заключен предварительный договор аренды сроком на 10 лет
                                        </li>
                                        <li style="text-align: justify;">Предусмотрена индексация 4% по соглашению сторон.</li>
                                    </ul>

                                    <p style="text-align: justify;">Оставшиеся 200 м2 (3 помещения) SimpleEstate будет вести
                                        активный поиск арендаторов ближе к вводу объектов в эксплуатацию:</p>

                                    <ul>
                                        <li style="text-align: justify;">Потенциальные арендаторы, которые могут занять соседние 3
                                            помещения - это аптека, алкомаркет, кафе, пункт выдачи и т.д.;
                                        </li>
                                        <li style="text-align: justify;">Маленькие арендаторы будут отлично работать на стабильном
                                            трафике «Магнита».
                                        </li>
                                    </ul>

                                    <div id="accel-snackbar" style=""></div>
                                </div>
                            </section>
                        </section>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>
                    </div>

                    <div class="plugin-estates-navigable-container__content-item"
                         ref="item1"
                         id="Описание объекта"
                    >
                        <div class="common-ckeditor">
                            <h1>Галерея фотографий</h1>
                        </div>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>

                        <plugin-gallery
                            v-bind:slides="[
                                {
                                    image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%A4%D0%B0%D1%81%D0%B0%D0%B4.jpeg',
                                    caption: 'Корпус №13 (1)',
                                },
                                {
                                    image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%9A%D1%80%D0%B0%D1%81%D0%B8%D0%B2%D1%8B%D0%B8_%D1%84%D0%B0%D1%81%D0%B0%D0%B4.jpeg',
                                    caption: 'Корпус №13 (2)',
                                },
                                {
                                    image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%9B%D1%83%D0%BF%D0%B0.jpeg',
                                    caption: 'Фасад',
                                },
                                {
                                    image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%9A%D0%BE%D0%BC%D0%BC%D0%B5%D1%80%D1%86%D0%B8%D1%8F.jpeg',
                                    caption: 'Коммерция на первых этажах',
                                },
                                {
                                    image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%93%D0%B5%D0%BD%D0%BF%D0%BB%D0%B0%D0%BD_%D0%96%D0%9A.png',
                                    caption: 'Генплан ЖК',
                                },
                                {
                                    image: 'https://cdn.simpleestate.ru/plugins/gallery/%D0%9F%D0%BB%D0%B0%D0%BD%D0%B8%D1%80%D0%BE%D0%B2%D0%BA%D0%B0.png',
                                    caption: 'Планировка помещений',
                                },
                            ]"
                        >
                            <section class="plugin-gallery">
                                <div class="swiper-container" ref="plugin-gallery-slider">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%A4%D0%B0%D1%81%D0%B0%D0%B4.jpeg"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>
                                            <div class="plugin-gallery__item-caption">
                                                Корпус №13 (1)
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%9A%D1%80%D0%B0%D1%81%D0%B8%D0%B2%D1%8B%D0%B8_%D1%84%D0%B0%D1%81%D0%B0%D0%B4.jpeg"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>
                                            <div class="plugin-gallery__item-caption">
                                                Корпус №13 (2)
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%9B%D1%83%D0%BF%D0%B0.jpeg"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>
                                            <div class="plugin-gallery__item-caption">
                                                Фасад
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%9A%D0%BE%D0%BC%D0%BC%D0%B5%D1%80%D1%86%D0%B8%D1%8F.jpeg"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>
                                            <div class="plugin-gallery__item-caption">
                                                Коммерция на первых этажах
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%93%D0%B5%D0%BD%D0%BF%D0%BB%D0%B0%D0%BD_%D0%96%D0%9A.png"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>
                                            <div class="plugin-gallery__item-caption">
                                                Генплан ЖК
                                            </div>
                                        </div>
                                        <div class="swiper-slide plugin-gallery__item">
                                            <div class="plugin-gallery__item-image swiper-lazy"
                                                 data-background="https://cdn.simpleestate.ru/plugins/gallery/%D0%9F%D0%BB%D0%B0%D0%BD%D0%B8%D1%80%D0%BE%D0%B2%D0%BA%D0%B0.png"
                                            >
                                                <div class="plugin-gallery__item-image-loader">
                                                    <ui-loader
                                                        v-bind:fixed="100"
                                                        v-bind:centered="true"
                                                    >
                                                    </ui-loader>
                                                </div>
                                            </div>
                                            <div class="plugin-gallery__item-caption">
                                                Планировка помещений
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="plugin-gallery__navigation">
                                    <div class="plugin-gallery__navigation-item _prev"
                                         ref="plugin-gallery-prev"
                                    >
                                        <icon name="chevron-left">
                                        </icon>
                                    </div>
                                    <div class="plugin-gallery__navigation-item _next"
                                         ref="plugin-gallery-next"
                                    >
                                        <icon name="chevron-right">
                                        </icon>
                                    </div>
                                </div>
                                <div class="plugin-gallery__pagination"
                                     ref="plugin-gallery-pagination"
                                >
                                </div>
                            </section>
                        </plugin-gallery>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>

                        <section class="common-columns-36">
                            <section class="common-columns-36__item _common_width_16 _common_offset_0 _sm_width_36 _sm_offset_0">
                                <div class="common-ckeditor">
                                    <h3><b>Высокая степень заселенности ЖК </b></h3>
                                    <p></p>
                                    <p>Супермаркет быстро наберет обороты, так как все дома рядом уже построены и заселены.</p>
                                </div>

                                <plugin-spacer inline-template>
                                    <div class="plugin-spacer _desktop" style="height: 0px"></div>
                                </plugin-spacer>
                                <plugin-spacer inline-template>
                                    <div class="plugin-spacer _mobile" style="height: 20px"></div>
                                </plugin-spacer>
                            </section>


                            <section class="common-columns-36__item _common_width_16 _common_offset_4 _sm_width_36 _sm_offset_0">
                                <div class="common-ckeditor">
                                    <h3><b>Комфортный срок ожидания </b></h3>
                                    <p></p>
                                    <p>Полгода до сдачи дома в эксплуатацию – комфортный срок ожидания, который позволяет начать
                                        получать аренду уже через 1 год</p>
                                </div>
                            </section>
                        </section>
                    </div>

                    <div class="plugin-estates-navigable-container__content-item"
                         ref="item2"
                         id="Расположение"
                    >
                        <div class="common-ckeditor">
                            <h1>Расположение</h1>
                        </div>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>

                        <plugin-map inline-template>
                            <article class="plugin-map">
                                <iframe
                                    src="https://yandex.ru/map-widget/v1/?um=constructor%3Ae8abde90621b5c4faebd3cae11c38aeeb9ae87e93afa1e83be778243bd2fae27&amp;source=constructor"
                                    width="500" height="400" frameborder="0"></iframe>
                            </article>
                        </plugin-map>

                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _desktop" style="height: 40px"></div>
                        </plugin-spacer>
                        <plugin-spacer inline-template>
                            <div class="plugin-spacer _mobile" style="height: 20px"></div>
                        </plugin-spacer>
                    </div>
                </div>
                <div class="plugin-estates-navigable-container__menu">

                    <div class="plugin-estates-navigable-container__menu-item">
                        <a class="plugin-estates-navigable-container__menu-item-link"
                           href="#Инвестиционный тезис"
                           v-bind:class="{
                            _active: activeItem === 0
                        }"
                           v-on:click="setActiveItem('Инвестиционный тезис')"
                        >
                            Инвестиционный тезис
                        </a>
                    </div>

                    <div class="plugin-estates-navigable-container__menu-item">
                        <a class="plugin-estates-navigable-container__menu-item-link"
                           href="#Описание объекта"
                           v-bind:class="{
                            _active: activeItem === 1
                        }"
                           v-on:click="setActiveItem('Описание объекта')"
                        >
                            Описание объекта
                        </a>
                    </div>

                    <div class="plugin-estates-navigable-container__menu-item">
                        <a class="plugin-estates-navigable-container__menu-item-link"
                           href="#Расположение"
                           v-bind:class="{
                            _active: activeItem === 2
                        }"
                           v-on:click="setActiveItem('Расположение')"
                        >
                            Расположение
                        </a>
                    </div>

                    <div class="plugin-estates-navigable-container__menu-button">
                        <ui-button
                            v-bind:href="registrationLink"
                            type="button"
                            style="background-color: #20242F"
                            target="_self"
                        >
                            Инвестировать
                        </ui-button>
                    </div>
                </div>
            </article>
        </plugin-estates-navigable-container-finuslugi>
    </page-estates-item-finuslugi>
</template>

<script>
/* eslint-disable */
export default {
    name: 'common-finuslugi-22',
};
</script>

<style scoped lang="less">

</style>
